import { Component, inject, input, signal } from '@angular/core';
import { InventoryActionDetailsComponent } from '../inventory-action-details.component';
import { ProviderService } from '../../../../providers/provider.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InventoryAction } from '../../../../models/inventory_action.model';
import moment from 'moment';
import { toUnderscore } from '../../../../utils/string-utils';
import { AdminService } from '../../../../admin/services/admin.service';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-inventory-action-for-pricing-details',
    templateUrl: './inventory-action-for-pricing-details.component.html',
    styleUrls: [
        './inventory-action-for-pricing-details.component.scss',
        '../inventory-action-details.component.scss',
    ],
    standalone: false
})
export class InventoryActionForPricingDetailsComponent {
  public readonly adminService = inject(AdminService);

  private readonly providerService = inject(ProviderService);

  private readonly router = inject(Router);

  private readonly snackBar = inject(MatSnackBar);

  dialogRef = input<MatDialogRef<InventoryActionDetailsComponent>>();

  loading = signal<boolean>(false);

  reloadInventoryAction = input(() => {});

  inventoryAction = input<InventoryAction>();

  constructor() {
  }

  get isFinished(): boolean {
    return this.inventoryAction().finish;
  }

  get isCompleted(): boolean {
    return this.inventoryAction().completed;
  }

  get isAnswered(): boolean {
    return !this.inventoryAction().draft;
  }

  get hasExpired(): boolean {
    return !this.isFinished && moment(this.inventoryAction().expiration_date).isBefore(moment());
  }

  get answeredAt(): Date {
    return this.inventoryAction().extra_params?.answered_at;
  }

  get remainingDaysToExpire() {
    return moment(this.inventoryAction().expiration_date).diff(moment(this.answeredAt), 'days');
  }

  requestPricing() {
    this.providerService.requestPricing({ inventory_action_for_pricing_id: this.inventoryAction().id }).subscribe(() => {
      this.reloadInventoryAction()();
      this.snackBar.open('Cotización enviada', 'Cerrar', { duration: 2000 });
    });
  }
  
  get title() {
    const action = this.adminService.getText(toUnderscore(this.inventoryAction()?.type));
    return `${action} #${this.inventoryAction()?.correlative_id}`;
  }

  get inventoryActionProducts() {
    return this.inventoryAction().inventory_action_products.sort((a, b) => a.product.name < b.product.name ? -1 : 1);
  }

  get children() {
    return this.inventoryAction().pricings_children.sort((a, b) => a.owner.name < b.owner.name ? -1 : 1);
  }

  get providers() {
    return this.providerService.getFromIds(this.inventoryAction().extra_params?.provider_ids);
  }

  get providersNames() {
    return this.providers.map(provider => provider.name).join(', ') + '.';
  }

  sortedProducts(inventoryActionProducts) {
    return inventoryActionProducts.sort((a, b) => a.name < b.name ? -1 : 1);
  }

  goBack() {
    if (this.dialogRef() instanceof MatDialogRef) {
      this.dialogRef().close();
    } else {
      this.router.navigate(['/main/inventory/pricings']);
    }
  }
}
